import { useEffect, FC, PropsWithChildren } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuthSelector } from '@wajeez-web/stores/auth';
import 'moment/locale/ar-sa';
import { EndpointItem, RouteItem } from '@wajeez-web/core/types';

export type RouteLayoutProps = {
  routes: RouteItem[];
  endpoints: EndpointItem[];
};

const AuthorizedLayout: FC<PropsWithChildren<any>> = ({ children }) => {
  const initURL = useAuthSelector((state) => state.auth.initURL);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!location.pathname || location.pathname === '/') {
      navigate(initURL || '/');
    }
  }, [initURL]);

  return children;
  
};

export default AuthorizedLayout;
